// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-line-horizontal';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M17.424 17.424H.576V.576M3.024 4.68h3.024m8.208 0h3.024M4.464 7.344h3.024M4.176 2.088H7.2m3.312 0h3.024M3.024 9.936h3.024m3.672 0h3.024m-5.256 2.592h3.024m-9.936 0H3.6M9 15.192h3.024m1.512-2.664h3.024'
  />
);

export const viewBox = '0 0 18 18';
